import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

// ✅ Imports locales
import heroFallback from '@/assets/images/hero-fallback.jpg';
import heroVideo from '@/assets/videos/hero.mp4';

const Hero = () => {
  return (
    <section
      id="inicio"
      className="relative flex min-h-screen items-center overflow-hidden bg-[#0A2540]"
    >
      {/* Imagen de respaldo (fallback) */}
      <img
        src={heroFallback}
        alt="Equipo profesional de Clean Work en instalaciones corporativas"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Video - siempre presente, con fallback a imagen */}
      <video
        src={heroVideo}
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Overlay gradiente */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#061a2c]/95 via-[#0A2540]/75 to-[#0A2540]/30" />

      {/* Contenido */}
      <div className="relative mx-auto w-full max-w-7xl px-5 pb-20 pt-32 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <p className="mb-6 font-bold uppercase tracking-[.28em] text-[#93ce1c] text-base">
            Servicios de limpieza corporativa
          </p>

          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl">
            LIMPIEZA PROFESIONAL
            <br />
            PARA EMPRESAS QUE
            <br />
            <span className="text-[#93ce1c]">CUIDAN SU IMAGEN</span>
          </h1>

          <p className="mt-7 max-w-2xl text-lg leading-8 text-blue-100">
            En CLEAN WORK ofrecemos soluciones profesionales de limpieza,
            personal capacitado y servicios adaptados a las necesidades de cada
            empresa.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <a
              href="#cotizacion"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 font-bold text-white hover:bg-emerald-700 bg-[#93ce1c] transition-colors"
            >
              SOLICITAR COTIZACIÓN
              <ArrowRight size={18} />
            </a>
            <a
              href="#servicios"
              className="border border-white/50 bg-white/10 px-7 py-4 text-center font-bold text-white backdrop-blur hover:bg-white/20 transition-colors"
            >
              CONOCER NUESTROS SERVICIOS
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;